/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash';
import Backbone from 'backbone';
import { View } from 'backbone.marionette';

import getUserIdFromDn from '../../util/getUserIdFromDn';
import { userHasRole } from '../../util/RoleUtils';
import showModal from '../../util/showModal';
import RevokeTask from '../../services/RevokeTask';
import ConfirmationModalView from '../ConfirmationModalView';
import TaskAssignModalView from '../TaskAssignModalView';
import TaskReassignModalView from '../TaskReassignModalView';

import './TaskActionsView.css';
import tmplTaskActionsView from './TaskActionsView.hbs';

const TaskActionsView = View.extend({
  template: tmplTaskActionsView,

  className: 'task-actions-view',

  ui: {
    reassign: '.reassign',
    release: '.release',
    assign: '.assign'
  },

  events: {
    'click @ui.reassign': 'onClickReassign',
    'click @ui.release': 'onClickRelease',
    'click @ui.assign': 'onClickAssign'
  },

  initialize() {
    const targets = this.model.get('targets');
    const targetRole = _.find(targets, { type: 'role' });
    const isTaskAdministrator = userHasRole('EMCEE - Task Admin');
    const isTaskAssigned = this.model.get('isAssigned');
    const isAdminAssignable = isTaskAdministrator && !isTaskAssigned;

    this.targetRoleDn = null;
    this.targetRoleName = null;
    if (targetRole) {
      this.targetRoleDn = targetRole.targetDn;
      this.targetRoleName = getUserIdFromDn(this.targetRoleDn);
    }
    this.model.set({ isAdminAssignable });
  },

  onClickReassign(e) {
    e.preventDefault();
    showModal({
      title: 'Reassign Task?',
      view: new TaskReassignModalView({
        model: new Backbone.Model({
          targetRole: this.targetRoleName,
          task: this.model.toJSON()
        })
      })
    });
  },

  onClickAssign(e) {
    e.preventDefault();
    showModal({
      title: 'Assign Task?',
      view: new TaskAssignModalView({
        model: new Backbone.Model({
          targetRole: this.targetRoleName,
          task: this.model.toJSON()
        })
      })
    });
  },

  onClickRelease(e) {
    e.preventDefault();
    const taskId = this.model.get('taskId');

    const message =
      `Are you sure you would like to release this task? This task will be ` +
      `removed from your assigned tasks, and will be available for others in ` +
      `the "${this.targetRoleName}}" role to claim.`;

    showModal({
      title: 'Release Task?',
      view: new ConfirmationModalView({
        confirmText: 'Release This Task',
        model: new Backbone.Model({
          message,
          onConfirm() {
            return RevokeTask(taskId);
          },
          onConfirmDone() {
            // Reload page after task has been successfully released.
            Backbone.history.loadUrl();
          }
        })
      })
    });
  }
});

export default TaskActionsView;
